function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16 26.6523C16 26.6523 7.42857 16.4141 7.42857 11.7977C7.42857 7.18132 11.2661 3.43901 16 3.43901C20.7339 3.43901 24.5714 7.18132 24.5714 11.7977C24.5714 16.4141 16 26.6523 16 26.6523ZM13.3744 28.8638L16 32L18.6256 28.8638C18.7037 28.7705 18.8406 28.6046 19.0279 28.3736C19.3348 27.9953 19.6753 27.5673 20.0413 27.0973C21.0868 25.7547 22.1326 24.3366 23.114 22.9001C23.8221 21.8635 24.4716 20.8533 25.0501 19.8786C26.9314 16.7088 28 14.0966 28 11.7977C28 5.25999 22.6061 6.55651e-07 16 6.55651e-07C9.39386 6.55651e-07 4 5.25999 4 11.7977C4 14.0966 5.06857 16.7088 6.94993 19.8786C7.52844 20.8533 8.17788 21.8635 8.88604 22.9001C9.86744 24.3366 10.9132 25.7547 11.9587 27.0973C12.3247 27.5673 12.6652 27.9953 12.9721 28.3736C13.1594 28.6046 13.2963 28.7705 13.3744 28.8638ZM16 7.87111C13.7973 7.87111 12.0117 9.62542 12.0117 11.7895C12.0117 13.9535 13.7973 15.7078 16 15.7078C18.2027 15.7078 19.9883 13.9535 19.9883 11.7895C19.9883 9.62542 18.2027 7.87111 16 7.87111Z",
  fill: "black"
});

var SvgPin = function SvgPin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pin.b9e1574c.svg";
export { ForwardRef as ReactComponent };